
import { Gender } from '../types';

export const calculateAge = (birthDate: string): number => {
  // Se birthDate for indefinido ou não for uma string válida, retorna 0
  if (!birthDate || typeof birthDate !== 'string') return 0;
  
  try {
    const today = new Date();
    // Limpa a string para pegar apenas YYYY-MM-DD
    const datePart = birthDate.trim().split('T')[0];
    
    // Se após o split não houver uma data válida (ex: ""), retorna 0
    if (!datePart) return 0;

    // Adicionar T12:00:00 garante que a data seja interpretada no fuso local 
    const birth = new Date(datePart + 'T12:00:00');
    
    if (isNaN(birth.getTime())) return 0;

    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    
    return age < 0 ? 0 : age;
  } catch (e) {
    console.error("Erro ao calcular idade:", e);
    return 0;
  }
};

// Jackson & Pollock 7-Site Formula for Body Density
export const calculateBodyDensity = (sumOfSkinfolds: number, age: number, gender: Gender): number => {
    if (sumOfSkinfolds <= 0 || age <= 0) return 0;
    const sumSq = sumOfSkinfolds * sumOfSkinfolds;
    if (gender === Gender.Male) {
        return 1.112 - (0.00043499 * sumOfSkinfolds) + (0.00000055 * sumSq) - (0.00028826 * age);
    } else { // Female
        return 1.097 - (0.00046971 * sumOfSkinfolds) + (0.00000056 * sumSq) - (0.00012828 * age);
    }
};

// Siri Equation for Body Fat Percentage
export const calculateBodyFatPercentage = (bodyDensity: number): number => {
    if (bodyDensity <= 0) return 0;
    return (495 / bodyDensity) - 450;
};

// Mifflin-St Jeor Equation for Basal Metabolic Rate (TMB)
export const calculateTMB = (weightKg: number, heightCm: number, age: number, gender: Gender): number => {
    if (weightKg <= 0 || heightCm <= 0 || age <= 0) return 0;
    if (gender === Gender.Male) {
        return Math.round((10 * weightKg) + (6.25 * heightCm) - (5 * age) + 5);
    } else { // Female
        return Math.round((10 * weightKg) + (6.25 * heightCm) - (5 * age) - 161);
    }
};

// Calculate BMI
export const calculateBMI = (weightKg: number, heightCm: number): number => {
    if (heightCm === 0 || weightKg === 0) return 0;
    const heightM = heightCm / 100;
    return weightKg / (heightM * heightM);
};
